<template>
    <div class="form-wrapper" v-if="!success">
        <form @submit.prevent="submit" class="col-xs-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2" ref="form">
            <div class="alert alert-danger" role="alert" v-if="error">
                {{error}}
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label" for="vorname">Vorname</label>
                <div class="col-md-9">
                    <input :class="{ 'is-invalid': validationErrors.hasOwnProperty('firstname') }" class="form-control" id="vorname"
                           maxlength="30" placeholder="Ihr Vorname" required type="text" v-model="firstname"/>
                    <div class="invalid-feedback">
                        {{validationErrors['firstname']}}
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 col-form-label" for="nachname">Nachname</label>
                <div class="col-md-9">
                    <input :class="{ 'is-invalid': validationErrors.hasOwnProperty('lastname') }" class="form-control" id="nachname"
                           maxlength="30" placeholder="Ihr Nachname" required type="text" v-model="lastname"/>
                    <div class="invalid-feedback">
                        {{validationErrors['lastname']}}
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 col-form-label" for="email">E-Mail</label>
                <div class="col-md-9">
                    <input :class="{ 'is-invalid': validationErrors.hasOwnProperty('email') }" class="form-control" id="email" maxlength="60"
                           pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$"
                           placeholder="Ihre E-Mail Adresse" required type="email" v-model="email"/>
                    <div class="invalid-feedback">
                        <span v-html="validationErrors['email']"></span>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-9 offset-md-3">
                    <div class="form-check">
                        <input class="form-check-input" id="termsCheck" required type="checkbox" v-model="terms">
                        <label class="form-check-label" for="termsCheck">
                            AGB akzeptiert
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group row" v-if="newsletter">
                <div class="col-lg-9 offset-lg-3">
                    <div class="form-check">
                        <input class="form-check-input" id="newslettersCheck" type="checkbox" v-model="newsletterOptIn">
                        <label class="form-check-label" for="newslettersCheck">
                            Ich möchte den kostenlosen Newsletter von Animod mit den neuesten Reisedeals abonnieren
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-12 form-submit">
                    <VueRecaptcha :sitekey="sitekey" @expired="onExpired" @verify="onVerify" ref="recaptcha" size="invisible"></VueRecaptcha>
                    <button :disabled="isProcessing" class="btn btn-primary submit-button" type="submit" v-if="meta.exhausted && meta.waitingListAvailable">In die Warteliste eintragen</button>
                    <button :disabled="isProcessing" class="btn btn-primary submit-button" type="submit" v-else-if="!meta.exhausted">Kostenlos anfordern</button>
                    <button :disabled="isProcessing" class="btn btn-primary submit-button" type="submit" v-else>Zum kostenlosen Animod Newsletter anmelden</button>
                </div>
            </div>
            <small class="form-text text-muted">
                Durch Abschicken dieses Formulars stimmen Sie der Speicherung und Verarbeitung Ihrer Daten gemäß unserer
                <a class="privacy-link" href="/datenschutz" rel="noopener" target="_blank">Datenschutzerklärung</a> zu.
            </small>
        </form>
    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    import ajax from '@/ajax';
    import parseUrlParams from '@/mixin/parseUrlParams';

    export default {
        name: "Form",
        mixins: [parseUrlParams],
        components: {
            VueRecaptcha
        },
        data() {
            return {
                firstname: '',
                lastname: '',
                email: '',
                terms: false,
                newsletterOptIn: false,
                sitekey: process.env.VUE_APP_RECAPTCHA_KEY,
                isProcessing: false,
                error: null,
                validationErrors: {},
                success: false
            };
        },
        props: {
            newsletter: Boolean,
            codeExpected: Boolean,
            meta: Object
        },
        methods: {
            submit() {
                if ( process.env.VUE_APP_DEBUG_MODE !== "true" ) {
                    this.$refs.recaptcha.execute();
                } else {
                    this.onVerify( null );
                }
            },
            async onVerify( recaptchaToken ) {
                this.isProcessing = true;
                this.validationErrors = {};
                this.error = null;
                this.$refs.recaptcha.reset();

                const {firstname, lastname, email, newsletterOptIn, landingPageId, codeId, codeExpected} = this;

                try {
                    await ajax.requestCode( {
                        firstname,
                        lastname,
                        email,
                        newsletterOptIn,
                        codeExpected,
                        recaptchaToken,
                        landingPageId,
                        codeId
                    } );
                    this.success = true;
                    this.$emit( 'code-requested-successfully', true );
                } catch ( e ) {
                    if ( e.response ) {
                        if ( e.response.status === 400 ) {
                            this.validationErrors = e.response.data.reduce( ( errors, current ) => {
                                if ( current.text === 'field.alreadyUsed' ) {
                                    errors[current.field] = "Sie haben bereits einen Code angefordert. Bitte überprüfen Sie Ihr Postfach. Für Rückfragen kontaktieren Sie bitte unseren freundlichen Kunden-Support per E-Mail an <a class=\"service-link\" style='color:#ff6a14;text-decoration:underline;' href=\"mailto:info@animod.de\">info@animod.de</a> oder telefonisch unter <a class=\"service-link\" style='color:#ff6a14;text-decoration:underline;' href=\"tel:+4922193374100\">0221 93374100</a>.";
                                } else {
                                    errors[current.field] = current.text;
                                }
                                return errors;
                            }, {} );
                        } else if ( e.response.status === 500 ) {
                            this.error = "Ein Problem ist aufgetreten. Bitte versuchen Sie es später noch einmal."
                        }
                    } else if ( e.request ) {
                        //Something went wrong with the request.
                        //Not sure if the user should be notified
                    } else {
                        //Generic error
                        //Not sure if the user should be notified
                        //this.error = e.message;
                    }
                } finally {
                    this.isProcessing = false;
                }
            },
            onExpired() {
                this.$refs.recaptcha.reset();
            }
        },
        mounted() {
            this.parsePageURL();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/variables";

    .form-wrapper {
        background-color: $main-background-color;
        border-bottom-left-radius: $main-border-radius;
        border-bottom-right-radius: $main-border-radius;
        margin-bottom: -$main-padding;
        padding-top: $main-padding*2;
        width: 100%;
    }

    form {
        padding-bottom: $main-padding*2;

        label {
            font-size: $body-copy-font-size;
            font-weight: $body-copy-font-weight;
        }

        @media (max-width: 575.98px) {
            label {
                overflow-wrap: break-word;
                word-wrap: break-word;
                -webkit-hyphens: auto;
                -ms-hyphens: auto;
                hyphens: auto;
            }
        }

        .invalid-feedback {
            background: $error-background-color;
            border-radius: $surface-border-radius;
            box-shadow: 0 0 5px 0 map_get($theme-colors, "primary");
            color: map_get($theme-colors, "primary");
            padding: 0.5rem;

            span {
                a.service-link {
                    color: $error-color !important;
                    text-decoration: underline !important;
                }
            }
        }

        .form-submit {
            text-align: right;
        }

        @media (max-width: 575.98px) {
            .form-submit {
                text-align: center;
            }
        }

        small {
            display: inline-block;
            margin-top: $main-margin;
        }

        .text-muted {
            color: $main-text-muted !important;
        }

        .privacy-link {
            color: inherit;
            text-decoration: underline;
        }
    }
</style>
